import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const useUnpublishPlatformAppMutation = createMutationHook(
  PlatformAppsApiClient.unpublishPlatformApp,
  {
    mutationKey: ['unpublishPlatformApp'],
  },
)

export const useUnpublishPlatformApp = () => {
  const queryClient = useQueryClient()
  const { unpublishPlatformAppMutation } = useUnpublishPlatformAppMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
      queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
    },
  })

  return {
    unpublishPlatformApp: unpublishPlatformAppMutation.mutate,
    isLoading: unpublishPlatformAppMutation.isLoading,
  }
}
